// pages/Login.js
import LoginPage from "../components/RegisterScreen/LoginForm";
import Footer from "../components/HomeScreen/Footer";

const Login = () => {
  return (
    <>
      <LoginPage />
      <Footer />
    </>
  );
}
export default Login;
